import Swiper from 'swiper';

let galleries = document.querySelectorAll('.js-partners');

galleries.forEach(gallery => makeGallery(gallery));


function makeGallery(gallery) {
	
	let thumbs = new Swiper(gallery.querySelector('.swiper-container'), {
		speed: 500,
		freeMode: false,
		slidesPerView: 3,
		slidesPerGroup: 3,
		// effect: 'fade',
		spaceBetween: 20,
		loop: false,
		centerInsufficientSlides: true,
		autoHeight: false,
		watchOverflow: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		pagination: {
			el:gallery.querySelector('.swiper-pagination'),
			clickable: true
		},
		// navigation: {
		// 	prevEl: gallery.querySelector('.swiper-button-prev'),
		// 	nextEl: gallery.querySelector('.swiper-button-next')
		// },
		// grabCursor: true
		breakpoints: {
			// when window width is <= 320px
			360: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 20
			},
			759: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 20
			}
		}
	});
}
